<template>
  <div>
    <v-container
      v-if="storeBarsPopulated"
      class="fill-height top-fifty"
      justify-center
    >
      <div class="result-apollo">
        <v-row class="add-bar-row">
          <v-spacer></v-spacer>
          <v-btn @click="goAddBar" color="accent" class="add-bar-btn"
            >Add Bar</v-btn
          >
          <v-btn
            @click="goPrevPage"
            color="accent"
            class="add-bar-btn"
            v-if="hasPrevPage"
            >Previous Page</v-btn
          >
          <v-btn @click="goNextPage" color="accent" v-if="hasNextPage"
            >Next Page</v-btn
          >
        </v-row>
        <v-toolbar
          color="secondary"
          class="bar-row"
          dark
          v-for="bar in storeBars"
          v-bind:key="bar._id"
        >
          <v-spacer></v-spacer>
          <span class="subheading">{{ bar.name }}</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="formatAndCommit(bar)">Edit Bar</v-btn>
        </v-toolbar>
      </div>
    </v-container>
    <ApolloQuery :query="barQuery" :variables="{ page }" v-else>
      <template v-slot="{ result: { loading, error, data } }">
        <v-container class="fill-height top-fifty" justify-center>
          <div v-if="loading" class="loading-apollo">Loading...</div>
          <div v-else-if="error" class="error-apollo">An error occurred</div>
          <div v-else-if="data" class="result-apollo">
            {{
              data && !storeBarsPopulated ? setBarsAndPages(data.allBars) : null
            }}
            <v-row class="add-bar-row">
              <v-spacer></v-spacer>
              <v-btn @click="goAddBar" color="accent" class="add-bar-btn"
                >Add Bar</v-btn
              >
            </v-row>
            <v-toolbar
              color="secondary"
              class="bar-row"
              dark
              v-for="bar in data.bars.docs"
              v-bind:key="bar._id"
            >
              <v-spacer></v-spacer>
              <span class="subheading">{{ bar.name }}</span>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="formatAndCommit(bar)"
                >Edit Bar</v-btn
              >
            </v-toolbar>
          </div>
          <div v-else class="no-result apollo">No result :(</div>
        </v-container>
      </template>
    </ApolloQuery>
  </div>
</template>
<script>
import barQuery from "../gql/barQuery";
import { defaultBar } from "../utils";
export default {
  data: function() {
    return {
      barQuery: barQuery
    };
  },
  computed: {
    storeBars() {
      return this.$store.state.allbars;
    },
    storeBarsPopulated() {
      return this.$store.state.allbars.length > 0;
    },
    page() {
      return this.$store.state.page;
    },
    hasNextPage() {
      return this.$store.state.hasNextPage;
    },
    hasPrevPage() {
      return this.$store.state.hasPrevPage;
    }
  },
  methods: {
    goNextPage() {
      if (this.hasNextPage) {
        this.$store.commit({ type: "nextPage" });
        this.$apollo
          .query({
            query: barQuery,
            variables: {
              page: this.page
            }
          })
          .then(({ data: { allBars } }) => {
            if (allBars) {
              this.setBarsAndPages(allBars);
            }
          });
      }
    },
    goPrevPage() {
      if (this.hasPrevPage) {
        this.$store.commit({ type: "prevPage" });
        this.$apollo
          .query({
            query: barQuery,
            variables: {
              page: this.page
            }
          })
          .then(({ data: { allBars } }) => {
            if (allBars) {
              this.setBarsAndPages(allBars);
            }
          });
      }
    },
    setBarsAndPages({ docs, hasPrevPage, hasNextPage }) {
      this.$store.commit({ type: "setBars", payload: docs });
      this.$store.commit({
        type: "setHasNextPage",
        payload: hasNextPage
      });
      this.$store.commit({
        type: "setHasPrevPage",
        payload: hasPrevPage
      });
    },
    goAddBar() {
      this.$router.push("add-bar");
    },
    formatAndCommit(bar) {
      let barCopy = Object.assign({}, bar);

      barCopy.dailySpecials = this.formatDailySpecialsOrHappyHours(
        barCopy.dailySpecials,
        "dailySpecials"
      );
      barCopy.happyHours = this.formatDailySpecialsOrHappyHours(
        barCopy.happyHours,
        "happyHours"
      );
      barCopy.imageURLs =
        barCopy.imageURLs.length < 1
          ? [...defaultBar.imageURLs]
          : barCopy.imageURLs.map(this.formatObjects);
      barCopy.address = this.formatObjects(barCopy.address);
      barCopy.hours = barCopy.hours.map(this.formatObjects);
      barCopy.prices = barCopy.prices.map(this.formatObjects);
      barCopy.hours =
        barCopy.hours.length < defaultBar.hours.length
          ? defaultBar.hours
          : barCopy.hours;
      barCopy.published = barCopy.published ? barCopy.published : false;
      barCopy.categories = barCopy.categories ? barCopy.categories : [];
      barCopy.imageURLs = barCopy.imageURLs.map(this.addFile);
      barCopy.dailySpecials = barCopy.dailySpecials.map(this.addFile);
      barCopy.happyHours = barCopy.happyHours.map(this.addFile);
      this.$store.commit({ type: "setCurrentBar", currentBar: barCopy });
      this.$router.push("edit-bar");
    },
    addFile(object) {
      if (!object.file) {
        object.file = [];
      }
      return object;
    },
    formatArrays(arrayOfObjects) {
      arrayOfObjects.forEach(object => {
        if (object.day) {
          object.selected = true;
        }
        this.formatObjects(object);
      });
      return arrayOfObjects;
    },
    formatObjects(object) {
      if (object && object.hasOwnProperty("__typename")) {
        delete object.__typename;
      }
      return object;
    },
    formatDailySpecialsOrHappyHours(arrayOfObjects, identifyingString) {
      return this.addDefaultDailySpecialsOrHappyHours(
        this.formatArrays(arrayOfObjects),
        identifyingString
      );
    },
    addDefaultDailySpecialsOrHappyHours(arrayOfObjects, identifyingString) {
      if (arrayOfObjects.length < 1) {
        return identifyingString === "happyHours"
          ? defaultBar.happyHours
          : defaultBar.dailySpecials;
      } else if (arrayOfObjects.length === 7) {
        return arrayOfObjects;
      } else {
        let localClone =
          identifyingString === "happyHours"
            ? [...defaultBar.happyHours]
            : [...defaultBar.dailySpecials];
        localClone.forEach((defaultEntry, index) => {
          arrayOfObjects.forEach(object => {
            if (defaultEntry.day === object.day) {
              localClone[index] = object;
            }
          });
        });
        return localClone;
      }
    }
  }
};
</script>
<style lang="scss">
.top-fifty {
  margin-top: 50px;
}
.result-apollo {
  width: 80%;
}
.bar-row {
  border-radius: 15px !important;
  margin-top: 5px;
  margin-bottom: 5px;
}
.add-bar {
  &-row {
    margin-top: 10px;
    margin-bottom: 30px;
  }
  &-btn {
    margin-right: 25px;
  }
}
</style>
